// extracted by mini-css-extract-plugin
module.exports = {"moneyCell__text":"styles_moneyCell__text__3_cRu","negative":"styles_negative__2tBlX","positive":"styles_positive__1mcnN"};